/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useRef as e,useEffect as t}from"react";import{useEvent as r}from"./use-event.js";function n(n,o){let u=e([]),s=r(n);t((()=>{let e=[...u.current];for(let[t,r]of o.entries())if(u.current[t]!==r){let t=s(o,e);return u.current=o,t}}),[s,...o])}export{n as useWatch};
//# sourceMappingURL=use-watch.js.map
